import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concat, from, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HiringService } from '../../../pages/hiring/services/hiring.service';

import { OrderByPipe } from './../../../shared/pipe/order-by.pipe';


@Component({
  selector: 'app-onboarding-invitation-modal',
  templateUrl: './onboarding-invitation-modal.component.html',
  styleUrls: ['./onboarding-invitation-modal.component.css']
})

export class OnboardingInvitationModalComponent implements OnInit {
  @Input() profileList: any[];

  portalSettings: any;
  employeeInfo: any;
  orderByPipe: any;
  formData: { [key: string]: any } = {};
  employees: any[] = [];
  showCheckSSN: boolean = false;
  processes: any[] = [];
  unusedProcesses: any[] = [];
  employeeLoading: boolean = false;
  employee$: Observable<any>;
  employeeInput$ = new Subject<any>();

  constructor(portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private hiringService: HiringService, public activeModal: NgbActiveModal) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.showCheckSSN = this.portalSettings.ONCheckSSNOnInvite.ConfigValue == "1";
    this.registerLookups();
  }

  private registerLookups() {
    //register observables used by super lookups
    this.employee$ = concat(
      this.employeeInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(term => ((term != null && term.length > 2) ?
          from(this.hiringService.getOnboardingEmployees(term)).pipe(
            catchError(() => of([]))) : of([])
        ))
      )
    );
  }

  checkSSN() {
    if (this.formData.noHireCheck != null && this.formData.noHireCheck.length != 11) {
      this.formData.noHireCheck = null;
    }
  }

  getAllDefaultsList() {
    this.hiringService.defaultsGetAllList(this.formData.profile).then((response: any[]) => {
      if (response != null) {
        var processes = response;
        var filteredProcesses = [];
        var unusedProcesses = [];
        processes.forEach((val: any) => {
          if (val.OnboardTaskIsDefault) {
            val.UseTask = true;
            filteredProcesses.push(val);
          }
          else {
            val.UseTask = false;
            unusedProcesses.push(val);
          }
        });
        this.processes = filteredProcesses;
        this.unusedProcesses = unusedProcesses;
      }
    });
  }

  addProcess() {
    this.formData.taskToAdd.UseTask = true;
    this.processes.push(this.formData.taskToAdd);
    this.unusedProcesses.splice(this.unusedProcesses.indexOf(this.formData.taskToAdd), 1);
    this.formData.taskToAdd = null;
  }

  employeeUpdate() {
    if (this.formData.employee != null) {
      setTimeout(() => {
        this.formData.firstName = this.formData.employee.FirstName;
        this.formData.lastName = this.formData.employee.LastName;
        this.formData.email = this.formData.employee.Email.trim();
        this.formData.noHireCheck = null;
      });
    }
  }

  sendClicked() {
    var usedProccesses = [];
    this.processes.forEach((val: any) => {
      usedProccesses.push(val.OnboardTaskDefID);
    });
    if (usedProccesses.length > 0) {
      this.formData.onboardTaskDefIDString = usedProccesses.join(',');
    }
    this.formData.action = "send";
    this.activeModal.close(this.formData);
  }

  removeTask(index: number) {
    this.unusedProcesses.push(this.processes[index]);
    this.unusedProcesses = this.orderByPipe.transform(this.unusedProcesses, "StepName", "asc");
    this.processes.splice(index, 1);
  }

  updateFormdata(data: string, field: any) {
    this.formData[field] = data;
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }
}

